module.exports = __webpack_public_path__ + "a68f8e06d164da242616103db275a1b0.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/fonts/fontello.woff?88483298
// module id = 12
// module chunks = 0